import AvField from "availity-reactstrap-validation/lib/AvField"
import AvForm from "availity-reactstrap-validation/lib/AvForm"
import { Modal, Row, Col, Alert } from "reactstrap"
import Location from "./Location"

const { useState, useEffect } = require("react")
import General from "services/GeneralEndpoints"
import { Link } from "react-router-dom"

const user = JSON.parse(localStorage.getItem("authUser"))
let generalService = new General(user)

const CompanyModal = props => {
  const [open, setopen] = useState(false)
  const [error, seterror] = useState()
  const [loading, setloading] = useState(false)
  const [isPlasticsCompany, setisPlasticsCompany] = useState(false)

  const [companyCategories, setcompanyCategories] = useState()

  useEffect(() => {
    fetchCompanyCategories()
  }, [])
  useEffect(() => {
    setopen(props.open)
  }, [props.open])
  useEffect(() => {
    setloading(props.loading)
  }, [props.loading])
  useEffect(() => {
    seterror(props.error)
  }, [props.error])

  function toggle() {
    setopen(!open)
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  const fetchCompanyCategories = () => {
    generalService.getCompanyCategories().then(response => {
      if (response.status) {
        const cats = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })
        setcompanyCategories(cats)
      }
    })
  }

  const submitRegistration = values => {
    props.submit(values)
  }

  const handleChangePlasticsCompany = e => {
    if (e.target.value === "yes") {
      setisPlasticsCompany(true)
    } else {
      setisPlasticsCompany(false)
    }
  }

  return (
    <Modal
      size="lg"
      isOpen={open}
      toggle={() => {
        toggle()
      }}
      scrollable={false}
    >
      <div className="modal-header">
        <h3 className="modal-title" id="staticBackdropLabel">
          Add Company
        </h3>
        <button
          type="button"
          className="btn-close"
          onClick={() => {
            props.toggleModal()
          }}
          aria-label="Close"
        ></button>
      </div>
      <AvForm
        className="mt-4"
        onValidSubmit={(e, v) => {
          submitRegistration(v)
        }}
      >
        <div className="modal-body">
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "center",
            }}
          ></div>
          {error ? <Alert color="danger">{error}</Alert> : null}

          <div className="p-2">
            <Row>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="name"
                    label="Company Name"
                    type="text"
                    required
                    placeholder="Enter Company Name"
                  />
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="company_category_id"
                    label="Company Category"
                    type="select"
                    required
                  >
                    <option>--Select--</option>
                    {companyCategories}
                  </AvField>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="type_registration"
                    label="Registration Type"
                    type="text"
                    required
                  />
                </div>
              </Col>

              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="tin"
                    label="Tax Identification Number"
                    type="text"
                    required
                    placeholder="Enter TIN"
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="telephone"
                    label="Phone"
                    type="phone"
                    validate={{
                      required: { value: true },
                      maxLength: {
                        value: 10,
                        errorMessage: "Enter a 10 digit phone number.",
                      },
                      minLength: {
                        value: 10,
                        errorMessage: "Enter a 10 digit phone number.",
                      },
                    }}
                    placeholder="Enter Phone Number"
                  />
                </div>
              </Col>

              <Col md="6">
                <div className="mb-3">
                  <AvField
                    id="email"
                    name="email"
                    label="Email"
                    className="form-control"
                    placeholder="Enter email"
                    type="email"
                    required
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="plastics_company"
                    label="Will you request Special Authorization for single-use plastics from this company?"
                    type="select"
                    onChange={handleChangePlasticsCompany}
                    required
                  >
                    <option>--Select--</option>
                    <option value={"yes"}>Yes</option>
                    <option value={"no"}>No</option>
                  </AvField>
                </div>
              </Col>
              {isPlasticsCompany ? (
                <Col md="6 mt-1">
                  <div className="mb-3 mt-1">
                    <AvField
                      id="avgMonthlyPlasticQuantity"
                      name="avgMonthlyPlasticQuantity"
                      label="Average quantity of Plastics used per month (Kg)"
                      className="form-control mt-3"
                      placeholder="Enter average quantity"
                      type="number"
                      required
                    />
                    <Alert className="mt-1" color="info">
                      Average quantity of plastics used in your company per
                      month. This measure should be in Kilograms (Kg)
                    </Alert>
                  </div>
                </Col>
              ) : null}
            </Row>
            <Row>
              <Col md="12">
                <div className="mb-3">
                  <AvField
                    name="activities"
                    label="Activities"
                    className="form-control"
                    placeholder="Enter Activities"
                    type="textarea"
                    required
                  ></AvField>
                </div>
              </Col>
            </Row>

            <hr></hr>
            <h5>Location Details</h5>
            <Row>
              <Col md="12">
                <div className="mb-3">
                  <AvField
                    name="address"
                    label="Address"
                    className="form-control"
                    placeholder="Enter Address"
                    type="text"
                    required
                  />
                </div>
              </Col>
            </Row>

            <Location />

            <hr></hr>
            <h5>Contact Person Details</h5>
            <Row>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="contact_person_name"
                    label="Name"
                    type="text"
                    placeholder="Enter Name"
                  />
                </div>
              </Col>

              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="contact_person_job_title"
                    label="Job Title"
                    className="form-control"
                    placeholder="Enter Job Title"
                    type="text"
                    required
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="contact_person_phone"
                    label="Phone"
                    type="phone"
                    validate={{
                      required: { value: true },
                      maxLength: {
                        value: 10,
                        errorMessage: "Enter a 10 digit phone number.",
                      },
                      minLength: {
                        value: 10,
                        errorMessage: "Enter a 10 digit phone number.",
                      },
                    }}
                    placeholder="Enter Phone Number"
                  />
                </div>
              </Col>

              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="contact_person_email"
                    label="Email"
                    className="form-control"
                    placeholder="Enter email"
                    type="email"
                    required
                  />
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => {
              props.toggleModal()
            }}
          >
            Close
          </button>
          {loading ? (
            <Link to="#" className="spinner-border text-info" />
          ) : (
            <button
              onClick={() => {
                // props.onHide()
                // setmodal(false)
              }}
              type="submit"
              className="btn btn-primary"
            >
              Add Company
            </button>
          )}
        </div>
      </AvForm>
    </Modal>
  )
}

export default CompanyModal
